import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Button, Grid, IconButton, Typography, makeStyles } from '@material-ui/core';

import { DeleteIcon, IUploader, Uploader, UploadInput, ValidatedTextField } from 'components';
import { ContentEmailValues } from 'features/admin/types';
import { getImageSrc } from 'helpers';

import Tip from 'components/Tip';

const { REACT_APP_IMGIX_HOST } = process.env;

const useStyles = makeStyles({
  image: {
    maxHeight: 200,
    width: '100%',
  },
});

const Image: FC = () => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<ContentEmailValues>();
  const classes = useStyles();

  const { banner } = values;

  function getImageProps() {
    if (banner.localUri) {
      return { src: window.URL.createObjectURL(banner.localUri) };
    }

    const imageUrl = `${REACT_APP_IMGIX_HOST}/${banner.key}?max-h=${200}auto=format`;
    return getImageSrc(imageUrl);
  }

  function renderImage() {
    return (
      <Fragment>
        <Grid container alignItems="center" spacing={3}>
          <Grid item>
            <img className={classes.image} {...getImageProps()} />
          </Grid>
          <Grid item>
            <IconButton onClick={() => setFieldValue('banner', null)}>
              <DeleteIcon iconProps={{ fontSize: 'large' }} />
            </IconButton>
          </Grid>
        </Grid>
        <ValidatedTextField
          name="banner_url"
          i18nKey="contentEmails:bannerImageURL"
          color="primary"
        />
      </Fragment>
    );
  }

  function renderUploader() {
    return (
      <Uploader disableCropper onSave={savedImage => setFieldValue('banner', savedImage)}>
        {(uploaderProps: IUploader) => (
          <UploadInput onUpload={uploaderProps.onUpload}>
            <Button component="span" variant="outlined">
              {t(`contentEmails:bannerImageUpload`)}
            </Button>
          </UploadInput>
        )}
      </Uploader>
    );
  }

  return (
    <Fragment>
      <Typography paragraph variant="body2">
        {t('contentEmails:bannerImage')}
      </Typography>
      <Typography paragraph>{t('contentEmails:bannerImageHelp')}</Typography>
      {!!banner ? renderImage() : renderUploader()}
      <Tip i18nKey="contentEmails:bannerImageTip" />
    </Fragment>
  );
};

export default Image;
